var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountAndExtraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "1232 568 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1249.575 568-7.575 7.5-2.5-2.5-7.5 7.575 2.5 2.5 5-5.075 2.5 2.5 10-10-2.425-2.5ZM1232 585.5v2.5h20v-2.5h-20Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Icon open-graph"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountAndExtraIcon);
export default __webpack_public_path__ + "static/media/DiscountAndExtraIcon.70a2b07a901ff55005d081099e0f7f1c.svg";
export { ForwardRef as ReactComponent };